export interface MerlinState {
    merlinMediaSearch: {
        searchTerm: {
            generating?: boolean;
            searchText?: string;
        };
        executing?: boolean;
        photos?: Array<Photo>;
        videos?: Array<Video>;
    };
    merlinEntitySearch: {
        executing?: boolean;
        hashtags?: Array<MerlinEntity>;
        people?: Array<MerlinEntity>;
        places?: Array<MerlinEntity>;
    };
}

type MerlinEntity = {
    entity: string;
    class_name: string;
    max_probability: number;
    instance_count: number;
};

export enum MerlinMediaType {
    PHOTO = 'photo',
    VIDEO = 'video',
}

export type MerlinMedia = {
    itemid: string;
    recordsequencenumber: number;
    arrivaldatetime: string;
    renditions: Array<Renditions>;
    friendlykey: string;
    title: string;
    headline: string;
    frames?: Array<Frame>;
    thumbnail?: string;
};

export type Photo = MerlinMedia;

export type Video = MerlinMedia;

export type Frame = {
    start: number;
    end: number;
    score: number;
    current: boolean;
};

export type Renditions = {
    fileextension: string;
    code: string;
    duid?: string;
    arrivedinfilingid: string;
    totalduration?: number;
    framerate?: number;
    averagebitrate?: string;
    format: string;
    title: string;
    type: string;
    videocoder?: string;
    producedaspectratio?: string;
    aspectratio?: string;
    logicalaspectratio?: string;
    binarypath: string;
    originalmediaid?: string;
    colorspace?: string;
    rel?: string;
    width: number;
    mimetype: string;
    href: string;
    height: number;
    samplerate?: string;
};

export interface AiSearchResults {
    agregations: { peope: People };
    hits: { hits: Array<Source> };
    timed_out: boolean;
    took: number;
    _shards: {
        failed: number;
        skipped: number;
        successful: number;
        total: number;
    };
}

export interface People {
    buckets: [{ key: string; doc_count: number }];
}

export interface Hits {
    _id: string;
    _index: string;
    _score: number;
    _source: Source;
    _type: string;
}

export interface Source {
    _source: {
        frames: any;
        arrivaldatetime: string;
        friendlykey: string;
        headline: string;
        itemid: string;
        recordsequencenumber: number;
        renditions: Array<Renditions>;
        title: string;
    };
}

export type SearchEntityResults = {
    hashtags: MerlinEntity[];
    people: MerlinEntity[];
    places: MerlinEntity[];
};
